import PropTypes from 'prop-types';
import PresentationRecord from '../../records/PresentationRecord';
import PDFViewer from '../pdf/PDFViewer';
import getPresentationSlideImages from '../../selectors/getPresentationSlideImages';
import ViewPageDrawer from './ViewPageDrawer';
import { MAIN_CONTENT_ANCHOR } from '../../lib/constants';
import styled from 'styled-components';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledContentAnchor = styled.div.withConfig({
  displayName: "ViewContent__StyledContentAnchor"
})(["position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden;"]);
const ViewContent = ({
  file,
  presentation,
  pageDrawerOpen
}) => {
  if (file === null) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    position: "relative",
    backgroundColor: "fill-field-default",
    "data-test-id": "view-content",
    minBlockSize: "0",
    flex: 1,
    children: [/*#__PURE__*/_jsx(StyledContentAnchor, {
      "aria-label": presentation.get('name'),
      tabIndex: 0,
      id: MAIN_CONTENT_ANCHOR
    }), /*#__PURE__*/_jsx(PDFViewer, {
      file: file,
      presentationName: presentation.get('name'),
      imagePlaceholders: getPresentationSlideImages(presentation),
      branding: presentation.brandingMetadata
    }), /*#__PURE__*/_jsx(ViewPageDrawer, {
      open: pageDrawerOpen,
      presentation: presentation
    })]
  });
};
ViewContent.propTypes = {
  file: PropTypes.string,
  presentation: PropTypes.instanceOf(PresentationRecord).isRequired,
  pageDrawerOpen: PropTypes.bool.isRequired
};
export default ViewContent;